import React from 'react';
import CircuitTable from './components/CircuitTable';
import Alert from 'features/POSRegisters/interfaces/AlertInfo';
import {NetworkCircuitScanDetails} from 'features/POSRegisters/interfaces/ScanDetails';

interface NetworkCircuit {
  scanResults: Partial<NetworkCircuitScanDetails>;
  alerts: Alert[];
}

export default function NetworkCircuit({list}: {list: NetworkCircuit[]}) {
  return (
    <>
      {list.map((item, idx) => (
        <CircuitTable key={`${item.scanResults?.deviceName}_${idx}`} {...item} />
      ))}
    </>
  );
}
